import { VStack } from "@chakra-ui/react";
import { EntityProfileFieldRow } from "../../../../../entityProfileModal/components/EntityProfilePreferenceControls";
import type {
  StaffingPreferenceField,
  StaffingPreferences,
  StaffingPreferencesBody,
} from "../staffingPreferences.types";
import { formatStaffingValue, toNullableBoolean } from "../staffingPreferences.utils";
import {
  StaffingBooleanValue,
  StaffingGenderValue,
  StaffingPreferenceEditor,
} from "./StaffingPreferenceControls";

export function StaffingPreferenceColumn(props: {
  draft: StaffingPreferencesBody | null;
  fields: StaffingPreferenceField[];
  onCommitDraft: (draft: StaffingPreferencesBody) => void;
  onChangeDraft: (draft: StaffingPreferencesBody) => void;
  preferences: StaffingPreferences;
}) {
  return (
    <VStack alignItems="stretch" spacing={0}>
      {props.fields.map((field) => {
        if (props.draft !== null) {
          const draft = props.draft;
          const draftValue = draft[field.key as keyof StaffingPreferencesBody];

          if (field.type === "boolean") {
            return (
              <EntityProfileFieldRow
                key={field.key}
                label={field.label}
                value={
                  <StaffingBooleanValue
                    value={typeof draftValue === "boolean" ? draftValue : null}
                    onChange={(nextValue) => {
                      const nextDraft: StaffingPreferencesBody = {
                        ...draft,
                        [field.key]: nextValue,
                      };

                      if (field.key === "kids" && nextValue === false) {
                        nextDraft.kidsCount = 0;
                      }

                      props.onChangeDraft(nextDraft);
                      props.onCommitDraft(nextDraft);
                    }}
                  />
                }
              />
            );
          }

          return (
            <EntityProfileFieldRow
              key={field.key}
              label={field.label}
              value={
                <StaffingPreferenceEditor
                  draft={draft}
                  fieldKey={field.key as keyof StaffingPreferencesBody}
                  onChangeDraft={props.onChangeDraft}
                  onCommitDraft={props.onCommitDraft}
                />
              }
            />
          );
        }

        let value: React.ReactNode = field.getValue
          ? field.getValue(props.preferences)
          : formatStaffingValue(props.preferences[field.key]);

        if (field.type === "boolean") {
          value = <StaffingBooleanValue value={toNullableBoolean(props.preferences[field.key])} />;
        }

        if (field.key === "gender") {
          value = <StaffingGenderValue value={props.preferences.gender} />;
        }

        return <EntityProfileFieldRow key={field.key} label={field.label} value={value} />;
      })}
    </VStack>
  );
}
